import axios from "axios";
import { getAllOrder } from "../orders/FetchApi";
const apiURL = process.env.REACT_APP_API_URL;

export const DashboardData = async () => {
  try {
    let res = await axios.post(`${apiURL}/api/customize/dashboard-data`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSliderImages = async () => {
  try {
    let res = await axios.get(`${apiURL}/api/customize/get-slide-image`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};


export const getOrdersForFinance = async (dispatch) => {
  let responseData = await getAllOrder();
  if (responseData && responseData.Orders) {
    dispatch({ type: "financeOrders", payload: responseData.Orders }); // <- juste le tableau
  }
};


export const postUploadImage = async (formData) => {
  try {
    let res = await axios.post(
      `${apiURL}/api/customize/upload-slide-image`,
      formData
    );
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const postDeleteImage = async (id) => {
  try {
    let res = await axios.post(`${apiURL}/api/customize/delete-slide-image`, {
      id,
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getProductsByCategory = async () => {
  try {
    let res = await axios.get(`${apiURL}/api/customize/products-by-category`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
